import {
    ActionIcon,
    Anchor,
    Avatar,
    Badge,
    Box,
    Button,
    Checkbox,
    createStyles,
    Group,
    Menu,
    NativeSelect,
    Pagination,
    Paper,
    Progress,
    ScrollArea,
    Skeleton,
    Table,
    Text,
    ThemeIcon,
    Tooltip,
    useMantineTheme,
} from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import {
    IconAlertCircle,
    IconAlertTriangle,
    IconAlertTriangleFilled,
    IconArrowRight,
    IconBarcode,
    IconCamera,
    IconChecklist,
    IconChevronDown,
    IconChevronRight,
    IconChevronUp,
    IconColorSwatch,
    IconDots,
    IconDragDrop,
    IconEdit,
    IconEye,
    IconHourglassLow,
    IconScan,
    IconSend,
    IconShirt,
    IconSubtask,
    IconTrash,
} from '@tabler/icons-react';
import { CountDisplay } from 'core/components/countDisplay/CountDisplay';
import { IconBadge, PulseIndicator, StyleSwatch } from 'core/components/index';
import PalettePopover from 'core/components/popovers/PalettePopover';
import { TextHighlight } from 'core/components/textHighlight/TextHighlight';
import ScanPopover from 'core/components/popovers/ScanPopover';
import SessionPopover from 'core/components/popovers/SessionPopover';
import TalentPopover from 'core/components/popovers/TalentPopover';
import { SampleEventType, SampleStatusTypes } from 'core/models/SampleModel';
import _ from 'lodash';
import moment from 'moment';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useSortBy, useTable, usePagination, useFilters, useGlobalFilter, useExpanded } from 'react-table';
import { DataFormats, shotChannelItems, shotChannels, StudioClientProdStatusTypes } from 'utils/constants';
import {
    getStyleStatusColor,
    getTotalDuration,
    getUserAvatarColour,
    getUserInitials,
    isJsonString,
    sampleAlphanumericFilter,
    childrenPriorityFilter,
    getClientApprovalStatusColor,
    dateSortFilter,
    getItemPriority,
    getClientLabel,
    getCompany,
    isSampleOtbSet,
    getSampleOtbRaw,
    parseSampleOtbMoment,
} from 'utils/helper';
import { logger } from 'utils/logger';
import DateDisplay, { isDateString } from 'core/components/dateDisplay/DateDisplay';
const EXPANDER_WIDTH = 30;
const useStyles = createStyles((theme, _params, getRef) => ({
    displayFooter: {
        position: 'fixed',
        bottom: 0,
        background: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
        right: theme.spacing.lg,
        left: 240,
        borderTop: '1px solid',
        borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[3],
    },
    // childCell: {
    //     borderTop: `1px dashed ${theme.colors.blue[4]}`,
    //     // position: 'relative',
    //     color: theme.colors.gray[7],
    //     '&:first-of-type': {
    //         borderLeft: theme.colorScheme === 'dark' ? `3px solid ${theme.colors.dark[4]}` : `3px solid ${theme.colors.blue[4]}`,
    //     },
    // },
}));

const SampleList = ({
    data,
    onItemClick,
    onMenuItemClick,
    onStatusClick,
    onItemSelected,
    selectedItems,
    filter,
    actionMenu,
    columns,
    rowMenuItems,
    showPopover = false,
    allowAssignCapture = true,
    totalCount = 0,
    loading = false,
    paginationSize = 100,
    setFilter,
    hiddenColumns,
    footerStyles,
    overrideGroupBy = false,
    type = 'session',
    aggData,
}) => {
    // const [uirows,setRows] = useState([]);
    const [items, setItems] = useState(selectedItems);
    const [expandedRows, setExpandedRows] = useState(new Set());
    const company = getCompany(aggData);
    const cols = React.useMemo(() => {
        var tmpCols = columns
            ? columns
            : [
                  {
                      // Build our expander column
                      id: 'expander', // Make sure it has an ID
                      Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
                          <>
                              {filter && filter.groupBy && filter.groupBy.length ? (
                                  <span {...getToggleAllRowsExpandedProps()}>{isAllRowsExpanded ? <IconChevronDown /> : <IconChevronRight />}</span>
                              ) : null}
                          </>
                      ),
                      Cell: ({ row, ...rest }) =>
                          // to build the toggle for expanding a row
                          {
                              let isChecked = false;
                              let indeterminate = false;
                              if (row.subRows) {
                                  // if all of the subrows are included in the selected items.`
                                  const commonItems = _.intersectionBy(row.originalSubRows, selectedItems, 'id');
                                  isChecked = commonItems.length === row.subRows.length;
                                  indeterminate = commonItems.length && commonItems.length < row.subRows.length ? true : false;
                              }
                              return row.canExpand ? (
                                  <Group>
                                      {/* <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} /> */}
                                      <div
                                          {...row.getToggleRowExpandedProps({
                                              style: {
                                                  // We can even use the row.depth property
                                                  // and paddingLeft to indicate the depth
                                                  // of the row
                                                  // paddingLeft: `${row.depth * 2}rem`,
                                                  display: 'flex',
                                              },
                                          })}>
                                          {row.isExpanded ? <IconChevronDown /> : <IconChevronRight />}
                                      </div>
                                      <Checkbox checked={isChecked} indeterminate={indeterminate} onChange={(e) => onItemSelected(e, row.original, e.currentTarget.checked, rest.page)}></Checkbox>
                                  </Group>
                              ) : null;
                          },
                      width: 50,
                  },
                  {
                      Header: 'Photo Code',
                      accessor: 'photoCode',
                      sortType: 'alphanumeric',
                      width: 200,
                  },
                  // {
                  //   Header: 'Item',
                  //   columns: [
                  {
                      Header: 'Style',
                      accessor: 'stylenumber',
                      sortType: 'alphanumeric',
                      width: 80,
                  },
                  {
                      Header: 'Sample Identifier',
                      accessor: 'sampleIdentifier',
                      sortType: 'alphanumeric',
                      width: 150,
                      show: true,
                  },
                  {
                      Header: 'Multi Shot',
                      accessor: 'multiShotFlag',
                      sortType: 'alphanumeric',
                      width: 100,
                  },
                  {
                      Header: 'Swatch',
                      accessor: 'colours',
                      sortType: 'alphanumeric',
                      width: 150,
                  },
                  {
                      Header: 'Outfitting',
                      accessor: 'outfittingFlag',
                      sortType: 'alphanumeric',
                      width: 100,
                  },
                  {
                      Header: 'Channels',
                      accessor: 'channels',
                      sortType: 'alphanumeric',
                      width: 100,
                  },

                  {
                      Header: 'Time Forecast',
                      accessor: 'timeForecast',
                      sortType: (rowA, rowB, columnId) => {
                          // Handle grouped data
                          if (rowA.original.subRows) {
                              // For grouped data, compare the first timeForecast of each group
                              const a = rowA.original.subRows[0]?.timeForecast;
                              const b = rowB.original.subRows[0]?.timeForecast;
                              if (!a || !b) return 0;
                              return moment(a[0]).unix() - moment(b[0]).unix();
                          }
                          // Handle regular data
                          const a = rowA.original[columnId];
                          const b = rowB.original[columnId];
                          if (!a || !b) return 0;
                          return moment(a[0]).unix() - moment(b[0]).unix();
                      },
                      width: 200,
                  },
                  {
                      Header: 'Status',
                      accessor: 'styleCount',
                      sortType: 'alphanumeric',
                  },
                  {
                      Header: 'Client Status',
                      accessor: 'clientProdStatus',
                      sortType: 'alphanumeric',
                      width: 120,
                  },
                  {
                      Header: 'Name',
                      accessor: 'name',
                      sortType: 'alphanumeric',
                      width: 300,
                  },

                  {
                      Header: 'Description',
                      accessor: 'descr',
                      sortType: 'alphanumeric',
                  },
                  {
                      Header: 'Notes',
                      accessor: 'notes',
                      sortType: 'alphanumeric',
                      width: 300,
                  },
                  {
                      Header: 'Size',
                      accessor: 'size',
                      sortType: 'alphanumeric',
                      width: 80,
                  },

                  {
                      Header: getClientLabel(company, 'otbDate'),
                      accessor: 'otbDate',
                      sortType: 'alphanumeric',
                      width: 130,
                  },

                  {
                      Header: 'Talent',
                      accessor: 'talentCodes',
                      sortType: 'alphanumeric',
                      width: 80,
                  },

                  {
                      Header: 'Department',
                      accessor: 'departmentStr',
                      sortType: 'alphanumeric',
                      width: 300,
                  },
                  {
                      Header: 'Created',
                      accessor: 'created',
                      sortType: 'dateSorter',
                      width: 100,
                  },
                  {
                      Header: 'Origin',
                      accessor: 'origin',
                      sortType: 'alphanumeric',
                      width: 80,
                  },
                  {
                      Header: '',
                      accessor: 'action',
                      width: 30,
                  },
              ];

        // set the visible state.
        return tmpCols;
    }, [filter.groupBy, data, columns, selectedItems, overrideGroupBy]);

    useEffect(() => {
        setItems(selectedItems);
    }, [selectedItems, setItems]);

    const tableProps = {
        columns: cols,
        data,
        expandedRows,
        setExpandedRows,
        selectedItems,
        onItemClick,
        showPopover,
        actionMenu,
        onItemSelected,
        onMenuItemClick,
        onStatusClick,
        allowAssignCapture,
        rowMenuItems,
        totalCount,
        loading,
        paginationSize,
        filter,
        setFilter,
        columnsToHide: hiddenColumns ?? [], // we just rename as the table component uses the same key
        footerStyles,
        overrideGroupBy,
        company,
    };

    return (
        <Box sx={{ width: '100%', overflowX: 'hidden', height: '100%' }}>
            <CustomTable {...tableProps} />
        </Box>
    );
};

const CustomTable = ({
    columns,
    data,
    expandedRows,
    setExpandedRows,
    selectedItems,
    onItemClick,
    onMenuItemClick,
    onItemSelected,
    onStatusClick,
    actionMenu,
    rowMenuItems,
    showPopover,
    allowAssignCapture,
    totalCount,
    loading,
    paginationSize,
    filter,
    setFilter,
    columnsToHide,
    footerStyles = {},
    overrideGroupBy = false,
    company,
}) => {
    // Use the state and functions returned from useTable to build your UI
    const { classes, cx } = useStyles();
    const [scrolled, setScrolled] = useState(false);
    const [navOpen] = useLocalStorage({ key: 'oi-navOpen' });

    const {
        getTableProps,
        // getTableBodyProps,
        headerGroups,

        prepareRow,
        rows,
        page, // Instead of using 'rows', we'll use page,
        // which has only the rows for the active page

        // The rest of these things are super handy, too ;)
        // canPreviousPage,
        // canNextPage,
        pageOptions,
        // pageCount,
        gotoPage,
        // nextPage,
        // previousPage,
        setPageSize,
        setHiddenColumns,
        state: {
            pageIndex,
            pageSize,
            sortBy,
            // globalFilter
        },
        // preGlobalFilteredRows,
        // setGlobalFilter
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageIndex: filter.pageIndex,
                pageSize: paginationSize,
                globalFilter: null,
                expanded: false,
                hiddenColumns: [...columnsToHide],
                // hiddenColumns: columns.filter((column) => {

                //     if (column.show === false) {
                //         return column.accessor;
                //     } else {
                //         return null;
                //     }
                // }),
                // sortBy: [
                //     {
                //         id: columns[1].accessor,
                //         desc: false,
                //     },
                // ],
                sortBy: filter.sortBy
                    ? [filter.sortBy]
                    : [
                          {
                              id: columns[1]?.accessor,
                              desc: false,
                          },
                      ],
            },
            sortTypes: {
                alphanumeric: React.useCallback((row1, row2, columnName) => sampleAlphanumericFilter(row1, row2, columnName, true), []),
                childrenPriority: React.useCallback((row1, row2, columnName) => childrenPriorityFilter(row1, row2, columnName, true), []),
                dateSorter: React.useCallback((rowA, rowB, columnId) => {
                    return dateSortFilter(rowA, rowB, columnId, true);
                }),
            },
        },

        useFilters,
        useGlobalFilter, // useGlobalFilter!
        useSortBy,
        useExpanded,
        usePagination,
    );

    useEffect(() => {
        if (columnsToHide) setHiddenColumns([...columnsToHide]);
    }, [columnsToHide]);
    // Store new sort state in fitler reducer
    useEffect(() => {
        // onChangeSort(sortBy);
        if (sortBy && sortBy.length) {
            const sortItem = sortBy[0];
            if ((filter.sortBy && filter.sortBy.id !== sortItem.id) || !filter.sortBy) {
                setFilter({ ...filter, sortBy: sortItem });
            }
        }
    }, [sortBy]);

    useEffect(() => {
        if (pageIndex >= pageOptions.length) {
            setTimeout(() => gotoPage(pageOptions.length ? pageOptions.length - 1 : 0), 10);
        }
    }, [page]);

    const getPanelWidth = useMemo(() => {
        let width = '100%';
        const element = document.getElementById('nav-wrapper');

        if (element) {
            // Get the computed style of the element
            // const computedStyle = window.getComputedStyle(element);
            // Get the marginLeft property from the computed style
            // const navWidth = computedStyle.getPropertyValue('width');

            // Parse the margin value to get a numeric value (remove 'px' if present)
            // const navWidthValue = parseFloat(navWidth);
            width = navOpen || navOpen === undefined ? `calc(100vw - ${220 + 30 - 10}px)` : `calc(100vw - ${68 + 30 - 10}px)`;
        }

        return width;
    }, [navOpen, window.innerWidth]);

    return (
        <ScrollArea
            sx={(theme) => ({
                height: '100%',
                width: getPanelWidth,

                // marginRight: -theme.spacing.xl,
                paddingRight: theme.spacing.xl,
                paddingBottom: theme.spacing.sm,
            })}
            onScrollPositionChange={({ y }) => setScrolled(y !== 0)}>
            {/* <Box sx={(theme) =>({height:'100%', width:getPanelWidth, marginRight: -theme.spacing.xl, paddingRight: theme.spacing.xl,
             paddingBottom:50})}> */}

            <div className='h-scroll-table-container' style={{ height: '100%' }}>
                <Table
                    highlightOnHover
                    size='sm'
                    {...getTableProps()}
                    sx={{ marginBottom: 10 }}
                    className={cx('h-scroll-table', { ['grouped-table']: (filter.groupBy && filter.groupBy.length) || overrideGroupBy })}>
                    <thead className={cx('scrollTableHeader', { ['scrolled']: scrolled })}>
                        {headerGroups.map((headerGroup, idx) => {
                            const { key, ...headerProps } = { ...headerGroup.getHeaderGroupProps() };
                            return (
                                <tr key={idx} {...headerProps}>
                                    {headerGroup.headers
                                        .filter((col) => {
                                            return columnsToHide && columnsToHide.indexOf(col.accessor) === -1;
                                        })
                                        .map((column, idx) => {
                                            const headerWidth = column.id === 'expander' ? 'auto' : column.width;
                                            var { key, ...colProps } = column.getHeaderProps(column.getSortByToggleProps());
                                            colProps.className = 'h-scroll-table-header-column';

                                            // if(column.id === 'expander' && loading){
                                            //     return null;
                                            // }
                                            if (column.id === 'action') {
                                                colProps.className = ' action-column';
                                                // colProps.style = {
                                                //     position: 'sticky',
                                                //     right: 0,
                                                // };
                                            }
                                            return (
                                                // Add the sorting props to control sorting. For this example
                                                // we can add them into the header props
                                                <th key={idx} {...colProps}>
                                                    <Group spacing={'xs'} style={{ width: headerWidth }} position='apart'>
                                                        <Text size='sm'>{column.render('Header')}</Text>
                                                        {/* Add a sort direction indicator */}

                                                        {column.id !== 'expander' ? (
                                                            <Group spacing={0}>
                                                                {column.isSorted ? (
                                                                    column.isSortedDesc ? (
                                                                        <ActionIcon color='brand' size='xs' radius='xl' variant='subtle'>
                                                                            <IconChevronDown size={16} />
                                                                        </ActionIcon>
                                                                    ) : (
                                                                        <ActionIcon color='brand' size='xs' radius='xl' variant='subtle'>
                                                                            <IconChevronUp size={16} />
                                                                        </ActionIcon>
                                                                    )
                                                                ) : (
                                                                    ' '
                                                                )}
                                                            </Group>
                                                        ) : null}
                                                    </Group>
                                                </th>
                                            );
                                        })}
                                </tr>
                            );
                        })}
                    </thead>

                    {loading ? (
                        <tbody>
                            {[1, 2, 3, 4, 5].map((i) => (
                                <tr key={i}>
                                    {columns.map((col, idx) => {
                                        if (columnsToHide && columnsToHide.indexOf(col.accessor) > -1) {
                                            return null;
                                        } else {
                                            return (
                                                <td key={idx} className='skeleton-cell'>
                                                    <Skeleton height={8} my='sm' />
                                                </td>
                                            );
                                        }
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            {page.map((row, idx) => {
                                // logger.log('rowkey', key)
                                prepareRow(row);

                                const rowProps = {
                                    row,
                                    selectedItems,
                                    onItemClick,
                                    onMenuItemClick,
                                    onItemSelected: (evt, original, isChecked) => {
                                        onItemSelected(evt, original, isChecked, rows);
                                    },
                                    onStatusClick,
                                    actionMenu,
                                    showPopover,
                                    allowAssignCapture,
                                    expandedRows,
                                    setExpandedRows,
                                    columns,
                                    columnsToHide,
                                    filter,
                                    allowSelect: true,
                                    company,
                                };

                                return <TableRow key={idx} rowId={idx} {...rowProps} />;
                            })}
                        </tbody>
                    )}
                </Table>
            </div>
            <Paper shadow='sm'>
                <Group position='' className={[classes.displayFooter, 'pagination-footer']} p='sm' style={footerStyles}>
                    {/* <Text size='sm'>
                        Total{' '}
                        <strong>
                            {data.length} of {totalCount}
                        </strong>{' '}
                    </Text> */}

                    <Group>
                        <Pagination
                            size={'sm'}
                            total={pageOptions.length}
                            withEdges
                            page={pageIndex + 1}
                            onChange={(idx) => {
                                gotoPage(idx - 1);
                                setFilter({ ...filter, pageIndex: idx - 1 });
                            }}
                        />
                        <Group>
                            <Text size='sm'>
                                Page{' '}
                                <strong>
                                    {pageIndex + 1} of {pageOptions.length}
                                </strong>{' '}
                            </Text>

                            <NativeSelect
                                size='sm'
                                value={pageSize}
                                onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                }}
                                data={[
                                    { value: 20, label: 'Show 20' },
                                    { value: 50, label: 'Show 50' },
                                    { value: 80, label: 'Show 80' },
                                    { value: 100, label: 'Show 100' },
                                    { value: 200, label: 'Show 200' },
                                ]}></NativeSelect>
                        </Group>
                    </Group>
                </Group>
            </Paper>
            {/* <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div> */}
            {/* </div>
        </ScrollArea>
        */}

            {/* </Box> */}
        </ScrollArea>
    );
};

export default SampleList;

const TableRow = ({
    row,
    rowId,
    selectedItems,
    onItemClick,
    onMenuItemClick,
    onStatusClick,
    onItemSelected,
    actionMenu,
    allowAssignCapture = false,
    expandedRows,
    setExpandedRows,
    columns,
    columnsToHide,
    filter,
    allowSelect = true,
    company,
}) => {
    const keyword = filter?.keyword || '';

    const theme = useMantineTheme();
    const props = { row, selectedItems, onItemClick, onMenuItemClick, onStatusClick, onItemSelected, actionMenu, allowAssignCapture };
    const navigate = useNavigate();
    const { key, ...rowProps } = row.getRowProps();
    const [isHovered, setIsHovered] = React.useState(false);

    const { classes } = useStyles();
    // Determine if this is a child row (subrow of an expanded parent)
    const isChildRow = row.depth > 0;
    const hasParentId = row.original.parentId != null;
    const isParentRow = row.canExpand || hasParentId || row.original.children;
    const isExpandedParent = (isParentRow && row.isExpanded) || expandedRows.has(row.original.id);

    // Build CSS classes for styling
    const rowClasses = [isParentRow ? 'parent-row' : '', isChildRow ? 'child-row' : '', isExpandedParent ? 'expanded-parent' : '', row.canExpand ? 'can-expand' : ''].filter(Boolean).join(' ');

    // Define theme-aware styles
    const getRowStyles = () => {
        // if (isChildRow) {
        //     const baseColor = theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0];
        //     const hoverColor = theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.blue[0];
        //     return {
        //         backgroundColor: isHovered ? hoverColor : baseColor,
        //         borderLeft: `3px solid ${theme.colors.blue[4]}`,
        //         transition: 'background-color 0.2s ease',
        //     };
        // }
        // if (isExpandedParent) {
        //     return {
        //         backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.blue[0],
        //         borderBottom: `2px solid ${theme.colors.blue[4]}`,
        //     };
        // }
        return {};
    };

    const getCellStyles = (cellId) => {
        if (isChildRow && cellId !== 'expander') {
            return {
                // paddingLeft: `${5 + (row.depth * 15)}px`,
                // fontSize: '0.9em',
                // color: theme.colorScheme === 'dark' ? theme.colors.gray[4] : theme.colors.gray[7],
                // borderTop: `1px dashed ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
                // position: 'relative',
            };
        }
        return {};
    };

    const isExpanded = expandedRows.has(row.original.id);

    const toggleExpansion = () => {
        const newExpandedRows = new Set(expandedRows);
        if (isExpanded) {
            newExpandedRows.delete(row.original.id);
        } else {
            newExpandedRows.add(row.original.id);
        }
        setExpandedRows(newExpandedRows);
    };

    const renderAssociatedStyles = () => {
        if (!isExpanded || !row.original.children) return null;

        const children = row.original.children;

        return children.map((child, index) => {
            // Create a mock row object for the child that mimics react-table structure
            const childRowMock = {
                original: child,
                canExpand: false,
                isExpanded: false,
                depth: row.depth + 1,
                subRows: [],
                originalSubRows: [],
                cells: columns
                    .filter((column) => !columnsToHide.includes(column.accessor))
                    .map((column) => ({
                        column: {
                            ...column,
                            id: column.id || column.accessor,
                        },
                        value: child[column.accessor || column.id],
                        render: () => child[column.accessor || column.id],
                        getCellProps: () => ({}),
                        row: {
                            canExpand: false,
                            isExpanded: false,
                            subRows: [],
                            originalSubRows: [],
                        },
                    })),
                getRowProps: () => ({}),
                getToggleRowExpandedProps: () => ({}),
            };

            return (
                <TableRow
                    key={`${row.original.id}_child_${index}`}
                    rowId={`${rowId}_child_${index}`}
                    row={childRowMock}
                    selectedItems={selectedItems}
                    onItemClick={onItemClick}
                    onMenuItemClick={onMenuItemClick}
                    onStatusClick={onStatusClick}
                    onItemSelected={onItemSelected}
                    actionMenu={actionMenu}
                    allowAssignCapture={allowAssignCapture}
                    expandedRows={expandedRows}
                    setExpandedRows={setExpandedRows}
                    columns={columns}
                    columnsToHide={columnsToHide}
                    filter={filter}
                    allowSelect={false}
                    company={company}
                />
            );
        });
    };

    return (
        <>
            <tr
                key={rowId}
                {...rowProps}
                className={rowClasses}
                style={getRowStyles()}
                // onMouseEnter={() => setIsHovered(true)}
                // onMouseLeave={() => setIsHovered(false)}
            >
                {row.cells.map((cell, cellIdx) => {
                    let renderCell;
                    const value = cell.column.id;

                    let checked = selectedItems.find((val) => val.id === row.original.id) ? true : false;
                    if (cell.row.canExpand) {
                        const commonItems = _.intersectionBy(row.originalSubRows, selectedItems, 'id');
                        checked = commonItems.length === row.subRows.length;
                    }
                    switch (true) {
                        case value.includes('expander'): {
                            var cellWidth = EXPANDER_WIDTH;
                            if (filter.groupBy) {
                                cellWidth = 60;
                            }
                            if (row.original.children && row.original.children.length > 0) {
                                renderCell = (
                                    <Group sx={{ maxWidth: cellWidth, minWidth: cellWidth }} pl={filter.groupBy && filter.groupBy.length ? 36 : 'sm'}>
                                        <span onClick={toggleExpansion} style={{ cursor: 'pointer' }}>
                                            {isExpanded ? <IconChevronDown /> : <IconChevronRight />}
                                        </span>
                                    </Group>
                                );
                            } else {
                                renderCell = <Group sx={{ maxWidth: cellWidth, minWidth: cellWidth }}>{cell.render('Cell')}</Group>;
                            }
                            break;
                        }
                        case value.includes('seasonSort'): {
                            renderCell = <Anchor onClick={() => onItemClick(row.original)}>{cell.render('Cell')}</Anchor>;
                            break;
                        }
                        case value.includes('styleNumber'):
                        case value.includes('stylenumber'): {
                            renderCell = (
                                <Link className='router-link' to={`/warehouse/styles/${cell.value}`}>
                                    {cell.render('Cell')}
                                </Link>
                            );
                            break;
                        }

                        case value.includes('seasonCode'): {
                            renderCell = (
                                <Link className='router-link' to={`/seasons/${cell.value}`}>
                                    {cell.render('Cell')}
                                </Link>
                            );
                            break;
                        }

                        case value.includes('sessionCode'): {
                            renderCell = (
                                <Link className='router-link' to={`/sessions/${cell.value}`}>
                                    {cell.render('Cell')}
                                </Link>
                            );
                            break;
                        }
                        // case value.includes('photographyCount'):
                        case value.includes('styleCount'): {
                            renderCell = !cell.row.canExpand ? (
                                <Group spacing={'xs'} sx={{ height: '100%', flexShrink: 1 }}>
                                    <Group noWrap spacing={'xs'}>

                                        {/* show the scan popoever if the scan data exists */}
                                        {row.original.scan ? (
                                            <ScanPopover onShowDetails={() => {}} data={{ ...row.original.scan, id: row.original.scan.gid }}>
                                                {CountDisplay({
                                                    val: parseInt(row.original['sampleCount']),
                                                    icon: <IconShirt size={18} strokeWidth={1} />,
                                                    // tooltip: 'Sample Acquired',
                                                    theme,
                                                    onClick: () => onStatusClick(SampleStatusTypes.SAMPLE_SCAN_COUNT, row.original),
                                                    hasIndicator: true,
                                                })}
                                            </ScanPopover>
                                        ) : (
                                            CountDisplay({
                                                val: parseInt(row.original['sampleCount']),
                                                icon: <IconShirt size={18} strokeWidth={1} />,
                                                tooltip: 'Sample Acquired',
                                                theme,
                                                onClick: () => onStatusClick(SampleStatusTypes.SAMPLE_SCAN_COUNT, row.original),
                                            })
                                        )}
                                        {CountDisplay({
                                            val: row.original['photographyCount'],
                                            icon: <IconCamera size={18} strokeWidth={1} />,
                                            tooltip: 'Photography Count',
                                            onClick: () => onStatusClick(SampleStatusTypes.SAMPLE_PHOTOGRAPHY_COUNT, row.original),
                                            theme,
                                        })}
                                    </Group>
                                    <Group noWrap spacing={'xs'}>
                                        {CountDisplay({
                                            val: row.original['taskCount'],
                                            icon: <IconSubtask size={18} strokeWidth={1} />,
                                            tooltip: 'Total Tasks',
                                            onClick: () => onStatusClick(SampleStatusTypes.SAMPLE_TASK_COUNT, row.original),
                                            theme,
                                        })}
                                        {CountDisplay({ val: row.original['taskCompleteCount'], icon: <IconChecklist size={18} strokeWidth={1} />, tooltip: 'Tasks Completed', theme })}
                                    </Group>
                                </Group>
                            ) : null;
                            break;
                        }
                        case value.includes('origin'): {
                            renderCell = row.original.origin ? (<Group width='100%' style={{ justifyContent: 'center' }}><Badge color='default' size='sm'>
                                                {row.original.origin}
                                            </Badge></Group>) : null;
                            break;
                        }
                        case value.includes('created'): {
                            let dateRender = (
                                <Group>
                                    {!row.canExpand ? (
                                        <Text size='sm'>
                                            {isDateString(row.original[value]) ? <DateDisplay value={row.original[value]} /> : ''}
                                        </Text>
                                    ) : null}
                                </Group>
                            );
                            // if there is a scan show via a scan
                            if (row.original.scan) {
                                dateRender = (
                                    <div>
                                        {row.original.scan ? (
                                            <>
                                                <div style={{ display: 'inline-block' }}>
                                                    <ScanPopover onShowDetails={() => {}} data={{ ...row.original.scan, id: row.original.scan.gid }}>
                                                        <Link to={`/warehouse/scans/${row.original.scan.gid}`} className='router-link'>
                                                            <Group spacing={'xs'}>
                                                                <DateDisplay value={row.original.scan.scanned} />
                                                                {/* <IconBarcode size={16} /> */}
                                                            </Group>
                                                        </Link>
                                                        
                                                    </ScanPopover>
                                                </div>
                                            </>
                                        ) : null}
                                    </div>
                                );
                            }
                            if (row.original.origin) {
                                dateRender = (
                                    <Group spacing={'xs'} style={{ lineHeight: 1.3, minWidth: 0 }}>
                                        {dateRender}
                                    </Group>
                                );
                            }
                            renderCell = dateRender;
                            break;
                        }
                        case value.includes('otb'):
                        case value.includes('distributionDate'):
                        case value.includes('completed'): {
                            renderCell = (
                                <Group sx={{ width: 120 }}>
                                    {!row.canExpand ? (
                                        <Text size='sm'>
                                            {isDateString(cell.value) ? <DateDisplay value={cell.value} /> : ''}
                                        </Text>
                                    ) : null}
                                </Group>
                            );
                            break;
                        }   

                        case value.includes('otbDate'): {
                            const isExpandableParent = row.canExpand || row.original.children?.length > 0;
                            const isCampaign = row.original.channels?.includes(shotChannelItems.CAMPAIGN.value);

                            if (isCampaign && isExpandableParent) {
                                const missingChildren = row.original.children.filter((child) => child.channels?.includes(shotChannelItems.CAMPAIGN.value) && !isSampleOtbSet(child));
                                if (missingChildren.length > 0) {
                                    renderCell = (
                                        <Group>
                                            <Badge
                                                leftSection={
                                                    <Group>
                                                        <IconAlertTriangle size={14} strokeWidth={1} />
                                                    </Group>
                                                }
                                                color='orange'>
                                                {missingChildren.length} Missing
                                            </Badge>
                                        </Group>
                                    );
                                }
                            } else if (isCampaign && !isSampleOtbSet(row.original) && !isExpandableParent) {
                                // if type campaign and value is empty show missing icon
                                renderCell = (
                                    <Group>
                                        <Badge
                                            leftSection={
                                                <Group>
                                                    <IconAlertTriangle size={14} strokeWidth={1} />
                                                </Group>
                                            }
                                            color='orange'>
                                            Missing
                                        </Badge>
                                    </Group>
                                );
                            } else {
                                const otbMoment = parseSampleOtbMoment(getSampleOtbRaw(row.original));
                                renderCell = (
                                    <Group>
                                        {!isExpandableParent ? (
                                            <Text size='sm'>{otbMoment ? <DateDisplay value={otbMoment} /> : ''}</Text>
                                        ) : null}
                                    </Group>
                                );
                            }
                            break;
                        }
                        case value.includes('status'): {
                            renderCell = <div onClick={() => onItemClick(row.original)}>{cell.value ? <Badge color={getStyleStatusColor(cell.value)}>{cell.value}</Badge> : null}</div>;
                            break;
                        }
                        case value.includes('multiShotFlag'): {
                            const assocStyles = row.original.assocStyles ? row.original.assocStyles.split(',') : [];
                            if (assocStyles.length) {
                                renderCell = (
                                    <div>
                                        {cell.value && cell.value === 'Y' ? (
                                            <Tooltip label={assocStyles.join(', ')}>
                                                <Badge leftSection={<IconColorSwatch size={12} style={{ display: 'flex' }} />} color='default'>
                                                    {assocStyles.length ? 'Grouped' : 'Required'}
                                                </Badge>
                                            </Tooltip>
                                        ) : null}
                                    </div>
                                );
                            } else {
                                renderCell = <div>{cell.value && cell.value === 'Y' ? <Badge color='default'>Required</Badge> : null}</div>;
                            }
                            break;
                        }

                        case value.includes('outfittingFlag'): {
                            renderCell = <div>{cell.value && cell.value === 'Y' ? <Badge color='green'>Available</Badge> : null}</div>;
                            break;
                        }
                        case value.toLowerCase().includes('keycode'):
                        case value.includes('instructions["Web Photography Code"]'):
                        case value.includes('photoCode'):
                        case value.includes('targetSort'): {
                            if (row.original.colours) {
                                renderCell = (
                                    <Group sx={{ minWidth: '130px', width: '100%' }}>
                                        <Group sx={{ flexShrink: 0, flexGrow: 1 }}>
                                            {row.original.mainShot && row.original.mainShot.length ? null : (
                                                <Checkbox
                                                    checked={selectedItems.find((val) => val.id === row.original.id) ? true : false}
                                                    onChange={(e) => onItemSelected(e, row.original, e.currentTarget.checked)}></Checkbox>
                                            )}

                                            {/* <SampleCheckBox  element={element} onItemSelected={(elem,selected) => selectHandler(elem,selected)} selectedItems={items} /> */}
                                            {/* <Group onClick={() => onItemClick(row.original)}> */}
                                            {/* <Image radius='sm' width={50} height={50} src={imgURL} /> */}
                                            {/* <IconShirt /> */}
                                            {/* </Group> */}
                                            {/* <Box sx={{ flexShrink: 1 }} onClick={() => onItemClick(row.original)}> */}

                                            <Box sx={{ flexShrink: 0, flexGrow: 1 }}>
                                                {/* <SamplePopover
                        data={{ targetSort: row.original.targetSort }}> */}
                                                {/* <SamplePopover key={row.original[cell.column.id]} data={{ targetSort: row.original[cell.column.id] }}> */}
                                                {/* <Anchor size='sm'> */}
                                                <Group position='apart'>
                                                    <Text
                                                        size='sm'
                                                        lineClamp={1}
                                                        // onClick={() => onItemClick(row.original)}
                                                    >
                                                        <TextHighlight text={row.original[cell.column.id]} keyword={keyword} />
                                                    </Text>

                                                    {row.original.liveData && row.original.liveData.files && row.original.liveData.files.length ? (
                                                        <Tooltip
                                                            position={rowId === 0 ? 'bottom' : 'top'}
                                                            label={`${moment(row.original.liveData.timestamps.min).format(DataFormats.TIME_FORMAT)} → ${moment(
                                                                row.original.liveData.timestamps.max,
                                                            ).format(DataFormats.TIME_FORMAT)}`}>
                                                            {/* <PulseIndicator /> */}
                                                            <Box>
                                                                <PulseIndicator />
                                                            </Box>
                                                        </Tooltip>
                                                    ) : null}
                                                </Group>
                                                {/* </Anchor> */}
                                                {/* </SamplePopover> */}

                                                {/* <Text sx={{ maxWidth: 600 }} lineClamp={2} size='sm'>
                                                {row.original.name}
                                            </Text> */}

                                                {/* </SamplePopover> */}
                                                {/* <Text size='xs' color='dimmed'>
                        {row.original.parentCode}
                      </Text>
                      <Text sx={{ maxWidth: 600 }} lineClamp={2} size='sm'>
                        {row.original.descr}
                      </Text> */}
                                            </Box>
                                        </Group>
                                        {/* {row.original.showIndicator?
                                    <div style={{position:'absolute', top:0, right:0}}>
                                    <LiveIndicator />
                                    </div>
                                    :null} */}
                                    </Group>
                                );
                            } else {
                                var display = <Text>{row.original.id}</Text>;

                                if (isJsonString(row.original.id) && Array.isArray(JSON.parse(row.original.id))) {
                                    const val = JSON.parse(row.original.id).map((item) => moment(item).toDate());
                                    const totalDuration = getTotalDuration(val);
                                    const timeForecast = val;
                                    logger.log(timeForecast, 'timeForecast');
                                    display = (
                                        <>
                                            {totalDuration.progress ? (
                                                <Group>
                                                    <Group>
                                                        <Text w={65}>{moment(timeForecast[0]).format('hh:mm A')}</Text> →<Text w={65}>{moment(timeForecast[1]).format('hh:mm A')}</Text>
                                                    </Group>
                                                    <Group>
                                                        {/* <Progress w={200} sx={{ flex: 1 }} value={totalDuration.progress} size='sm' /> */}

                                                        <Group mr={'xs'} spacing={4}>
                                                            <Text style={{ display: 'flex', alignItems: 'center' }} p={0} color={totalDuration.duration < 0 ? 'red' : 'dimmed'}>
                                                                <IconHourglassLow size={14} />
                                                            </Text>
                                                            <Text color={totalDuration.duration < 0 ? 'red' : 'dimmed'} size={'xs'}>
                                                                Duration: {totalDuration.display}
                                                            </Text>
                                                        </Group>
                                                    </Group>
                                                </Group>
                                            ) : (
                                                <Group>
                                                    <Text color='dimmed'>No value</Text>
                                                </Group>
                                            )}
                                        </>
                                    );
                                }
                                logger.log(row.original, ' :::::');
                                if (row.original.type === 'group' && row.original.id === StudioClientProdStatusTypes.REVIEW.value) {
                                    display = <Badge color={getClientApprovalStatusColor(row.original.id)}>{StudioClientProdStatusTypes.REVIEW.label}</Badge>;
                                } else if (row.original.type === 'group' && row.original.id === undefined) {
                                    display = <Text color={'dimmed'}>Not available</Text>;
                                }

                                if (value.includes('KEYCODE')) {
                                    display = <TextHighlight text={row.original[value]} keyword={keyword} />;
                                } else if (row.original.type !== 'group') {
                                    display = <TextHighlight text={row.original.instructions ? row.original.instructions['Web Photography Code'] : ''} keyword={keyword} />;
                                }

                                renderCell = cell.row.canExpand ? (
                                    <Group sx={{ minWidth: '50px' }}>
                                        <Group sx={{ flexShrink: 0 }}>
                                            {/* <Checkbox
                                            checked={selectedItems.find((val) => val.id === row.original.id) ? true : false}
                                            onChange={(e) => onItemSelected(e, row.original, e.currentTarget.checked)}></Checkbox> */}
                                            <Group sx={{ flexShrink: 1 }}>
                                                {/* {value.includes('instructions["Web Photography Code"]') ? (
                                                <Text size='sm' lineClamp={1} sx={{ maxWidth: '350px' }}>
                                                    {row.original.instructions['Web Photography Code']}
                                                </Text>
                                            ) : (
                                                <Text size='sm' lineClamp={1} sx={{ maxWidth: '350px' }}>
                                                    {row.original[cell.column.id]}
                                                </Text>
                                            )} */}
                                                {display}
                                                {row.original.subRows?.length ? <Badge color={'brand'}>{row.original.subRows?.length}</Badge> : null}
                                            </Group>
                                        </Group>
                                    </Group>
                                ) : (
                                    <Group sx={{ minWidth: '50px' }}>
                                        <Group sx={{ flexShrink: 0, paddingLeft: allowSelect ? 0 : 40 }}>
                                            {allowSelect && (
                                                <Checkbox
                                                    checked={selectedItems.find((val) => val.id === row.original.id) ? true : false}
                                                    onChange={(e) => onItemSelected(e, row.original, e.currentTarget.checked)}></Checkbox>
                                            )}
                                            <Group sx={{ flexShrink: 1 }}>
                                                {/* {row.original.instructions ? row.original.instructions['Web Photography Code'] : ''} */}
                                                {display}
                                                {row.original.children && <Badge color={'brand'}>{row.original.children.length}</Badge>}
                                            </Group>
                                        </Group>
                                    </Group>
                                );
                            }

                            break;
                        }
                        case value.includes('notes'): {
                            renderCell = <Text size='sm'>{cell.render('Cell')}</Text>;
                            break;
                        }
                        case value.includes('descr'):
                        case value.includes('description'): {
                            renderCell = (
                                <Text sx={{ maxWidth: 600, minWidth: 200 }} lineClamp={2} size='sm'>
                                    <TextHighlight text={String(cell.value ?? '')} keyword={keyword} />
                                </Text>
                            );
                            break;
                        }
                        case value.includes('instructions["Web Stock OTB Date"]'): {
                            const webStockOtb = row.original?.instructions?.['Web Stock OTB Date'];
                            const webStockOtbMoment = parseSampleOtbMoment(webStockOtb);

                            renderCell = (
                                <Box sx={{ maxWidth: 200, minWidth: 100 }}>
                                    {webStockOtbMoment ? <DateDisplay value={webStockOtbMoment} /> : webStockOtb}
                                </Box>
                            );
                            break;
                        }

                        case value.includes('metadata_toplevelcategory'): {
                            renderCell = (
                                <div onClick={() => onItemClick(row.original)}>
                                    <Badge color='violet' sx={{ maxWidth: 150 }}>
                                        {cell.render('Cell')}
                                    </Badge>
                                </div>
                            );
                            break;
                        }
                        case value.includes('channels'): {
                            renderCell = (
                                <div onClick={() => onItemClick(row.original)}>
                                    {row.original?.channels?.length ? (
                                        <Group spacing={3}>
                                            {row.original.channels.map((val, idx) => {
                                                const channel = shotChannels.find((channel) => channel.value === val);
                                                if(!channel) return null;
                                                return (
                                                <Fragment key={idx}>
                                                    {val.length > 1 ? (
                                                        <IconBadge
                                                            key={idx}
                                                            color={channel?.color}
                                                            icon={channel?.icon}
                                                            sx={{
                                                                maxWidth: 150,
                                                            }}>
                                                            {val}
                                                        </IconBadge>
                                                    ) : null}
                                                </Fragment>
                                            );
                                            })}
                                        </Group>
                                    ) : null}
                                </div>
                            );
                            break;
                        }
                        case value.includes('instructions'): {
                            //const keys = Object.keys(row.original.instructions);
                            const regex = /"(.*?)"/; // Regular expression to match the value inside double quotes

                            const match = cell.column.id.match(regex);
                            let key = match ? match[0] : '';
                            key = key.replace(/"/g, '');

                            renderCell = (
                                <div onClick={() => onItemClick(row.original)} style={{ minWidth: 80 }}>
                                    {key === 'department' ? `${row.original.instructions['Dept']} - ` : ''}
                                    {row.original.instructions ? row.original.instructions[`${key}`] : ''}

                                    {/* <Table striped>
                  <tbody>
                  {keys.map((key,idx) => {
                    return (<tr key={idx}>
                      <td style={{width:220}}><Text pl={'sm'} color='dimmed' mr={'md'}>{key}: </Text></td>
                      <td>{row.original.instructions[key]}</td>
                    </tr>)
                  })}
                  </tbody>
                </Table> */}
                                </div>
                            );
                            break;
                        }

                        case value.includes('issuer'): {
                            const userInitials = row.original[value] ? getUserInitials(row.original[value].split(' ')[0], row.original[value].split(' ')[1]) : '';
                            const themeCol = getUserAvatarColour(userInitials);

                            renderCell = (
                                <>
                                    {row.original[value] ? (
                                        <Group noWrap>
                                            <Avatar variant='filled' title={`${row.original[value]}`} color={themeCol} size={30} radius={40}>
                                                {userInitials}
                                            </Avatar>
                                            <Text>{row.original[value]}</Text>
                                        </Group>
                                    ) : null}
                                </>
                            );
                            break;
                        }
                        case value.includes('timeForecast'): {
                            // convert unix timestamps to moment objects

                            // const timeForecast = row.original[value] ? row.original[value]?.map((timestamp) => moment.unix(timestamp).toDate()) : [null, null];
                            const totalDuration = getTotalDuration(row.original[value]);
                            renderCell = (
                                <>
                                    {totalDuration.progress ? (
                                        <Box>
                                            <Group>
                                                <Text>{moment(row.original.timeForecast[0]).format('hh:mm A')}</Text> →<Text>{moment(row.original.timeForecast[1]).format('hh:mm A')}</Text>
                                            </Group>
                                            <Group>
                                                {/* <Progress w={'100%'} sx={{ flex: 1 }} value={totalDuration.progress} size='sm' /> */}

                                                <Group mr={'xs'} spacing={4} align='center'>
                                                    <Text mt={0} style={{ display: 'flex', alignItems: 'center' }} p={0} color={totalDuration.duration < 0 ? 'red' : 'dimmed'}>
                                                        <IconHourglassLow size={14} />
                                                    </Text>
                                                    <Text color={totalDuration.duration < 0 ? 'red' : 'dimmed'} size={'xs'}>
                                                        Duration: {totalDuration.display}
                                                    </Text>
                                                </Group>
                                            </Group>
                                        </Box>
                                    ) : (
                                        <Box>
                                            <Text></Text>
                                        </Box>
                                    )}
                                </>
                            );

                            break;
                        }

                        case value.includes('scan'): {
                            renderCell = (
                                <div>
                                    {/* <Badge color='violet' sx={{ maxWidth: 150 }}>
                                        {cell.render('Cell')}
                                    </Badge> */}

                                    {row.original.scan ? (
                                        <>
                                            <div style={{ display: 'inline-block' }}>
                                                <ScanPopover onShowDetails={() => {}} data={{ ...row.original.scan, id: row.original.scan.gid }}>
                                                    <Link to={`/warehouse/scans/${row.original.scan.gid}`} className='router-link'>
                                                        <DateDisplay value={row.original.scan.scanned} />
                                                    </Link>
                                                </ScanPopover>
                                            </div>
                                        </>
                                    ) : null}
                                </div>
                            );
                            break;
                        }

                        case value.includes('clientProdStatus'): {
                            if (row.original.channels?.includes(shotChannelItems.CAMPAIGN.value)) {
                                const cellValue = row.original.clientProdStatus;
                                var progress = row.original.clientProdStatus;
                                var label = row.original.clientProdStatus;
                                if (cellValue === StudioClientProdStatusTypes.COMPLETE.value) {
                                    progress = 100;
                                    label = StudioClientProdStatusTypes.COMPLETE.label;
                                } else if (cellValue === StudioClientProdStatusTypes.REVIEW.value) {
                                    progress = 50;
                                    label = StudioClientProdStatusTypes.REVIEW.label;
                                } else {
                                    progress = 0;
                                    label = StudioClientProdStatusTypes.DRAFT.label;
                                }
                                // renderCell = (
                                //     <div>
                                //         <Tooltip label={label}>
                                //             <Progress value={progress} />
                                //         </Tooltip>
                                //     </div>
                                // );
                                renderCell = (
                                    <Group align='center' position='center'>
                                        <Badge color={progress === 100 ? 'green' : progress === 50 ? 'yellow' : 'gray'}>{label}</Badge>
                                    </Group>
                                );
                            } else {
                                renderCell = (
                                    <Group align='center' position='center'>
                                        <Text color='dimmed' size='xs'></Text>
                                    </Group>
                                );
                            }
                            break;
                        }

                        // <div style={{ display: 'flex', alignItems: 'center', minWidth: 170, width: 150 }}>
                        //                 {progressSteps.map((step, index) => (
                        //                     <React.Fragment key={index}>
                        //                         {/* Show badge at current step, otherwise show dot */}
                        //                         {index === currentStepIndex ? (
                        //                             <Badge size="sm" variant="flled" style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
                        //                                 {label}
                        //                             </Badge>
                        //                         ) : (
                        //                             <div
                        //                                 style={{
                        //                                     width: 12,
                        //                                     height: 12,
                        //                                     borderRadius: '50%',
                        //                                     flexShrink: 0,
                        //                                     backgroundColor: index < currentStepIndex ? theme.colors.brand[5] : theme.colors.gray[5],
                        //                                     opacity: index > currentStepIndex ? 0.4 : 1
                        //                                 }}
                        //                             />
                        //                         )}

                        //                         {/* Connecting line after each step except the last */}
                        //                         {index < progressSteps.length - 1 && (
                        //                             <div
                        //                                 style={{
                        //                                     height: 2,
                        //                                     width: '100%',
                        //                                     backgroundColor: index < currentStepIndex ? theme.colors.brand[5] : theme.colors.gray[5],
                        //                                     opacity: index >= currentStepIndex ? 0.4 : 1
                        //                                 }}
                        //                             />
                        //                         )}
                        //                     </React.Fragment>
                        //                 ))}
                        //             </div>

                        case value.includes('action'): {
                            // const menuItems = rowMenuItems?rowMenuItems:null;
                            // logger.log(row.original, 'row.original', actionMenu);
                            var cellMenu = [];
                            if (
                                row.original.channels?.includes(shotChannelItems.CAMPAIGN.value) &&
                                row.original.clientProdStatus !== StudioClientProdStatusTypes.COMPLETE &&
                                row.original.clientProdStatus !== StudioClientProdStatusTypes.REVIEW &&
                                !row.original.seasonSort
                            ) {
                                cellMenu.push({
                                    handler: (data) => {
                                        onMenuItemClick({
                                            type: SampleEventType.SAMPLE_EDIT,
                                            data: data,
                                        });
                                    },
                                    label: 'Send for Client Review',
                                    icon: <IconSend size={14} />,
                                });
                            }

                            if (row.original.parentId) {
                                cellMenu.push({
                                    handler: (data) => {
                                        onMenuItemClick({
                                            type: SampleEventType.SAMPLE_REMOVE_FROM_GROUP_SHOT,
                                            data: data,
                                        });
                                    },
                                    label: 'Remove from Group Shot',
                                    icon: <IconTrash size={14} />,
                                });
                            }

                            renderCell =
                                cell.row.canExpand || row.original.mainShot?.length || row.original.parentId?.length ? (
                                    <>{row.original.parentId?.length ? <SampleItemMenu {...props} item={row.original} actionMenu={cellMenu} /> : ''}</>
                                ) : (
                                    <Group
                                        sx={{
                                            width: '100%',
                                            alignContent: 'center',
                                            justifyContent: 'end',
                                            maxWidth: allowAssignCapture ? 'auto' : '80px',
                                            minWidth: allowAssignCapture ? '250px' : 'auto',
                                        }}>
                                        {/* {actionMenu ? actionMenu : null} */}
                                        {allowAssignCapture && row.original.photographyCount ? (
                                            <Button variant='outline' size='sm' onClick={(e) => onMenuItemClick({ event: e, type: SampleEventType.SAMPLE_ASSIGN_CAPTURES, data: row.original })}>
                                                Style Guide Selections
                                            </Button>
                                        ) : null}
                                        {/* show a button to update the client status if styles channel is a campaign shot */}
                                        {/* {row.original.channels?.includes('Campaign') && row.original.clientProdStatus !== StudioStatusTypes.COMPLETE && row.original.clientProdStatus !== StudioStatusTypes.REVIEW && (
                                        <Button variant='outline' size='sm' onClick={(e) => onMenuItemClick({ event: e, type: SampleEventType.SAMPLE_UPDATE_CLIENT_STATUS, data: row.original })}>
                                            Send for client review
                                        </Button>
                                    )} */}
                                        <SampleItemMenu {...props} item={row.original} menuItems={actionMenu} />
                                        {/* <SampleItemMenu onMenuItemClick={(e) => onMenuClick(e,row.original)}/> */}
                                    </Group>
                                );
                            break;
                        }
                        case value.includes('studioSessionCodes'): {
                            renderCell = (
                                <Group style={{ minWidth: 140 }}>
                                    {row.original.studioSessionCodes?.map((val, idx) => (
                                        <div key={idx}>
                                            <SessionPopover onShowDetails={() => {}} data={{ ssPart: val }}>
                                                <Link to={`/sessions/${val}`} className='router-link'>
                                                    {val}
                                                </Link>
                                            </SessionPopover>
                                        </div>
                                    ))}
                                </Group>
                            );
                            break;
                        }

                        case value.includes('talentCodes'): {
                            renderCell = (
                                <>
                                    <Avatar.Group spacing='sm' style={{ paddingLeft: 0 }}>
                                        {row.original['talents']?.map((talent, idx) => {
                                            const userInitials = talent.fullName ? getUserInitials(talent.fullName.split(' ')[0], talent.fullName.split(' ')[1]) : '';
                                            const themeCol = getUserAvatarColour(userInitials);
                                            const margin = idx ? -10 : 0;
                                            return (
                                                <TalentPopover key={idx} data={talent} onShowDetails={() => navigate(`/talent/${talent.code}`)}>
                                                    <Avatar
                                                        key={idx}
                                                        variant='gradient'
                                                        component={Link}
                                                        to={`/talent/${talent.code}`}
                                                        src={talent.latestURL}
                                                        sx={{ marginLeft: margin }}
                                                        title={`${talent.fullName}`}
                                                        color={themeCol}
                                                        size={25}
                                                        radius={40}>
                                                        {talent.fullName?.charAt(0)}
                                                    </Avatar>
                                                </TalentPopover>
                                            );
                                        })}
                                    </Avatar.Group>
                                </>
                            );
                            break;
                        }

                        case value.includes('colours'): {
                            renderCell = (
                                <div>
                                    <PalettePopover position='top-end' styleId={row.original.stylenumber} company={company}>
                                        <StyleSwatch showTooltip={false} autoWidth={true} doFetch={true} styleId={row.original.stylenumber} placeholder='' />
                                    </PalettePopover>
                                </div>
                            );
                            break;
                        }

                        case value.includes('priority'): {
                            var priority = getItemPriority(row.original.priority, getSampleOtbRaw(row.original));
                            renderCell = (
                                <Group align='center' position='center' spacing={'xs'}>
                                    <ThemeIcon size='sm' variant='light' color={priority.color}>
                                        {priority.icon}
                                    </ThemeIcon>
                                    <Text size='md'>{priority.label}</Text>
                                </Group>
                            );
                            break;
                        }

                        default: {
                            renderCell = cell.row.canExpand ? (
                                <></>
                            ) : (
                                <div style={{ minWidth: 80 }}>
                                    <Text lineClamp={2} size='sm'>
                                        <TextHighlight text={String(cell.value ?? '')} keyword={keyword} />
                                    </Text>
                                </div>
                            );
                        }
                    }
                    var { key, ...cellProps } = cell.getCellProps();
                    var cellClass = checked ? 'cellChecked' : '';

                    // Add child row styling
                    if (isChildRow) {
                        cellClass += ' child-cell';
                    }

                    // Apply theme-aware cell styles
                    const dynamicCellStyles = getCellStyles(cell.column.id);
                    cellProps.style = {
                        ...cellProps.style,
                        ...dynamicCellStyles,
                    };

                    if (cell.column.id === 'action') {
                        // cellProps.style = {
                        //     position: 'sticky',
                        //     right: 0,
                        //     verticalAlign: 'top',
                        //     borderLeft: '1px solid #e0e0e0',
                        // };
                        cellClass += ' action-column';
                    } else if (cell.column.id === 'expander') {
                        // cellProps.style = {
                        //     maxWidth: '60px',
                        // };
                    }
                    return (
                        <td key={cellIdx} {...cellProps} className={`${isChildRow ? classes.childCell : ''} ${cellClass}`.trim()}>
                            {/* <Group sx={{minWidth:150}}> */}
                            {renderCell}
                            {/* </Group> */}
                        </td>
                    );
                })}
            </tr>
            {renderAssociatedStyles()}
        </>
    );
};

const SampleItemMenu = (props) => {
    var defaultMenu = [
        {
            handler: () =>
                props.onMenuItemClick({
                    type: SampleEventType.SAMPLE_VIEW,
                    data: props.item,
                }),
            icon: <IconEye size={14} />,
            label: 'View Sample',
        },
        {
            handler: () =>
                props.onMenuItemClick({
                    type: SampleEventType.SAMPLE_EDIT,
                    data: props.item,
                }),
            icon: <IconEdit size={14} />,
            label: 'Edit Style Record',
        },
        {
            handler: () =>
                props.onMenuItemClick({
                    type: SampleEventType.SAMPLE_ASSIGN_CAPTURES,
                    data: props.item,
                }),
            icon: <IconDragDrop size={14} />,
            size: 14,
            label: 'Style Guide Selections',
        },
        {
            handler: () =>
                props.onMenuItemClick({
                    type: SampleEventType.SAMPLE_DELETE,
                    data: props.item,
                }),
            color: 'red',
            icon: <IconTrash size={14} />,
            size: 14,
            label: 'Unassign Sample',
        },
        {
            handler: () =>
                props.onMenuItemClick({
                    type: SampleEventType.SAMPLE_VIEW_CAPTURES,
                    data: props.item,
                }),
            color: 'red',
            icon: <IconCamera size={14} />,
            size: 14,
            label: 'Open in Captures',
        },
    ];

    // Only include this if the data type doesn't have mainShot or parentId
    if (
        (props.item.mainShot?.length === 0 || !props.item.mainShot) &&
        props.item.channels?.includes(shotChannelItems.CAMPAIGN.value) &&
        props.item.clientProdStatus !== StudioClientProdStatusTypes.COMPLETE &&
        props.item.clientProdStatus !== StudioClientProdStatusTypes.REVIEW
    ) {
        defaultMenu.push({
            handler: () =>
                props.onMenuItemClick({
                    type: SampleEventType.SAMPLE_UPDATE_CLIENT_STATUS,
                    data: [props.item],
                }),
            color: 'red',
            icon: <IconSend size={14} />,
            size: 14,
            label: 'Send for Client Review',
        });
    }

    const menuItems = props.actionMenu ? props.actionMenu : defaultMenu;

    return (
        <Menu position='bottom-end' withinPortal>
            <Menu.Target>
                <ActionIcon>
                    <IconDots />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                {menuItems.map((val, idx) => (
                    <Menu.Item key={idx} onClick={() => val.handler(props.item)} icon={val.icon}>
                        {val.label}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    );
};
